module.exports = __webpack_public_path__ + "static/media/yure.e9524641.jpg";